import { OrderStatusEnum } from '../enums/orderStatus';
import { OrderModel } from '../models/order';
import { convertDateStringToNormalDateTimeString } from './convertDateFormat';
import { convertOrderStatusEnumToStatusCode } from './convertOrderStatusValue';

export const findOrderCreateTime = (order: OrderModel): string => {
  try {
    const findDate: string = order?.orderStatusTime?.dateTime?.filter(
      (item) =>
        item?.statusOrder?.code ===
        convertOrderStatusEnumToStatusCode(OrderStatusEnum.CURRENT_ORDER)
    )[0]?.time;
    const result=convertDateStringToNormalDateTimeString(findDate);
    
    return result==="Invalid date" ? convertDateStringToNormalDateTimeString(order?.createdAt) : result;
  } catch (err) {
    return convertDateStringToNormalDateTimeString(order?.createdAt);
  }
};
